/** A smooth scroll emits its first `scroll` event within a few frames; frames do not pass while the main thread is busy. */
const SCROLL_START_FRAMES = 6;
const SCROLL_END_FALLBACK_MS = 1500;

export const waitForWindowScrollEnd = () =>
    new Promise<boolean>(resolve => {
        let hasScrollStarted = false;
        let remainingFrames = SCROLL_START_FRAMES;
        let frameId = 0;

        const finish = (hasScrollEnded: boolean) => {
            cancelAnimationFrame(frameId);
            clearTimeout(fallbackTimeout);
            window.removeEventListener("scroll", markScrollStarted);
            window.removeEventListener("scrollend", handleScrollEnd);
            resolve(hasScrollEnded);
        };

        const markScrollStarted = () => {
            hasScrollStarted = true;
        };

        const handleScrollEnd = () => finish(true);

        const finishIfScrollNeverStarted = () => {
            if (hasScrollStarted) {
                return;
            }

            remainingFrames -= 1;

            if (remainingFrames === 0) {
                finish(false);
                return;
            }

            frameId = requestAnimationFrame(finishIfScrollNeverStarted);
        };

        const fallbackTimeout = "onscrollend" in window ? undefined : setTimeout(() => finish(false), SCROLL_END_FALLBACK_MS);

        window.addEventListener("scroll", markScrollStarted, { passive: true, once: true });
        window.addEventListener("scrollend", handleScrollEnd, { once: true });
        frameId = requestAnimationFrame(finishIfScrollNeverStarted);
    });
